import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 dtrs-flex-time-box" }
const _hoisted_2 = { class: "radio-info-label" }
const _hoisted_3 = { class: "radio-info-label" }

import { ref, watch, computed } from 'vue';
import { DEFAULT_TOLERANCE, ALL_DAY_TOLERANCE } from './date_time_range_generators';
import { _normalizeTimes } from '@/utils/parse_time_strings';
import InfoButton from '@/components/InfoButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecificTimesSelector',
  props: {
    "modelValue": {
  type: Array as () => string[]
},
    "modelModifiers": {},
    "timePlusMinus": {
  type: Array as unknown as () => [number, number],
  default: () => [...DEFAULT_TOLERANCE]
},
    "timePlusMinusModifiers": {},
  },
  emits: ["update:modelValue", "update:timePlusMinus"],
  setup(__props) {

function timeFormat(hour: number, minute: number, ampm = true): string {
  if (ampm) {
    // from 24 hour to am/pm
    const ampm = hour >= 12 ? 'pm' : 'am';
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    if (minute === 0) {
      return `${h12} ${ampm}`;
    }
    return `${h12}:${String(minute).padStart(2, '0')} ${ampm}`;
  } else {
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  }
}

const selectedTimes = _useModel<string[]>(__props, "modelValue");
const timePlusMinus = _useModel<[number, number]>(__props, 'timePlusMinus');
const timeOptions = ref<string[]>(Array.from({ length: 15 }, (_, h) => timeFormat(h + 6, 0, true))); // 6:00 to 20:00

const allDay = computed({
  get: () => timePlusMinus.value[0] === ALL_DAY_TOLERANCE[0] && timePlusMinus.value[1] === ALL_DAY_TOLERANCE[1],
  set: (val: boolean) => {
    timePlusMinus.value = val ? [...ALL_DAY_TOLERANCE] : [...DEFAULT_TOLERANCE];
  }
});

const _selectedTimesRef = ref<string[]>([]);
const selectedTimesRef = computed({
  get: () => {
    if (allDay.value) return timeOptions.value;
    return _selectedTimesRef.value;
  },
  set: (value: string[]) => {
    // console.log('selectedTimesRef set to', value);
    _selectedTimesRef.value = value;
  }
});


watch(selectedTimesRef, (value: string[]) => {
  // console.log('selectedTimesRef changed to', value);
  if (allDay.value) {
    selectedTimes.value = [];
    return;
  }
  selectedTimes.value = value;
});

// Normalize entered times to HH:MM 24h (flexible entry via copilot)
function normalizeTimes(values: string[]) {
  const normalized = _normalizeTimes(values, timeFormat);
  const unique = Array.from(new Set(normalized));
  selectedTimesRef.value = unique;
  return unique;
}

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_col, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_radio_group, {
          modelValue: allDay.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allDay).value = $event)),
          direction: "horizontal",
          "hide-details": "",
          class: "mb-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_radio, {
              label: "Entire Day",
              value: true
            }, {
              label: _withCtx(({label}) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, _toDisplayString(label), 1),
                  _createVNode(InfoButton, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, " TEMPO only collects data during daylight hours. Depending on the time of year, different time ranges will be available on a given day ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_radio, {
              label: "Specific Times",
              value: false
            }, {
              label: _withCtx(({label}) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, _toDisplayString(label), 1),
                  _createVNode(InfoButton, null, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, " Select the times of day you want to include data for. TEMPO will only collect data during daylight hours. The times you pick will be used for each region and corrected for timezone differences. For example, creating a time range of 9:00-11:00 would pull data from 9:00-11:00 Eastern Time for New York, and 9:00-11:00 Pacific Time for Los Angeles. ")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (!allDay.value)
          ? (_openBlock(), _createBlock(_component_v_combobox, {
              key: 0,
              modelValue: selectedTimesRef.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((selectedTimesRef).value = $event)),
                normalizeTimes
              ],
              items: timeOptions.value,
              label: "Add/select times",
              multiple: "",
              chips: "",
              "closable-chips": "",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              hint: "24h format HH:MM (e.g., 09:00, 14:30)",
              "persistent-hint": ""
            }, null, 8, ["modelValue", "items"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})